"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.share = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var share = function share(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'share-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '21',
    viewBox: '0 0 20 21',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M10 0.939331L13.5303 4.46966C13.8232 4.76255 13.8232 5.23743 13.5303 5.53032C13.2374 5.82321 12.7626 5.82321 12.4697 5.53032L10.75 3.81065V12.45C10.75 12.8642 10.4142 13.2 10 13.2C9.58579 13.2 9.25 12.8642 9.25 12.45V3.81065L7.53033 5.53032C7.23744 5.82321 6.76256 5.82321 6.46967 5.53032C6.17678 5.23743 6.17678 4.76255 6.46967 4.46966L10 0.939331ZM3.25 7.99999C3.25 7.58578 3.58579 7.24999 4 7.24999H7C7.41421 7.24999 7.75 7.58578 7.75 7.99999C7.75 8.41421 7.41421 8.74999 7 8.74999H4.75V18.25H15.25V8.74999H13C12.5858 8.74999 12.25 8.41421 12.25 7.99999C12.25 7.58578 12.5858 7.24999 13 7.24999H15.9996C16.4138 7.24999 16.75 7.58578 16.75 7.99999V19C16.75 19.4142 16.4142 19.75 16 19.75H4C3.58579 19.75 3.25 19.4142 3.25 19V7.99999Z',
    fill: '#4B5563'
  }));
};

exports.share = share;